import React from 'react';
import Paper from '@material-ui/core/Paper';
import { makeStyles, createStyles } from '@material-ui/core/styles';

import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import { GetEMCSettings, EMCSettingType, CreateDefalutEMCSettingType } from '../../../../function/EMCModel';
import ECMSettingGridRow from './EMCSettingGridRow';

import { ComboBoxItemTypeSOD } from './../../../atoms/ComboBox/ItemComboBoxStrOD';

import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(
  createStyles({
    //テーブルヘッダセル
    tableHeaderCell: {
      borderWidth: '1px',
      borderColor: '#dcdcdc',
      borderStyle: 'solid',
      backgroundColor: 'grey',
      textAlign: 'center',
      color: 'white',
    },
  })
);

type EMCSettingGridProps = {
  tableStyle: string;
  emcSettingList: EMCSettingType[];
  onChangeEvent: (value: EMCSettingType) => void;
  cmoboBoxItemList: ComboBoxItemTypeSOD[];
};

const EMCSettingGrid: React.FC<EMCSettingGridProps> = (props) => {
  const { t } = useTranslation();

  const classes = useStyles();
  return (
    <>
      <TableContainer component={Paper} className={props.tableStyle}>
        <Table stickyHeader size="small" aria-label="a dense table">
          <TableHead>
            <TableRow>
              <TableCell className={classes.tableHeaderCell}>{t('EMCSettingGrid.No', 'No')}</TableCell>
              <TableCell className={classes.tableHeaderCell}> {t('EMCSettingGrid.実行', '実行')}</TableCell>
              <TableCell className={classes.tableHeaderCell}>{t('EMCSettingGrid.ユニットNo', 'ユニットNo')}</TableCell>
              <TableCell className={classes.tableHeaderCell}>{t('EMCSettingGrid.局番', '局番')}</TableCell>
              <TableCell className={classes.tableHeaderCell}>
                {t('EMCSettingGrid.機器番号名称', '機器番号・名称')}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {props.emcSettingList.map((row, index) => {
              return (
                <ECMSettingGridRow
                  key={row.indexNo}
                  emcSettingRow={row}
                  onChangeEvent={props.onChangeEvent}
                  cmoboBoxItemList={props.cmoboBoxItemList}
                ></ECMSettingGridRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default EMCSettingGrid;
